import { getSubscriptionsUsageRejected, getSubscriptionsUsageResolved, } from '@innovyze/stylovyze/lib/actions/subscriptionsUsage.actions';
import { createReducer } from '@reduxjs/toolkit';
export const initialState = {
    initialized: false,
    list: [],
};
const reducer = {
    [getSubscriptionsUsageResolved.toString()]: (state, action) => ({
        initialized: true,
        list: action.payload.subscriptions,
    }),
    [getSubscriptionsUsageRejected.toString()]: state => ({
        ...state,
        initialized: true,
        failed: true,
    }),
};
export default createReducer(initialState, reducer);
